import { ButtonGroup } from 'components/buttons'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { taskActivities, TaskActivity } from './taskActivity'

interface Props {
  className?: string
  counts?: Record<TaskActivity, number> // omitted for now
  onClick: (selected: TaskActivity) => void
  selected: TaskActivity
}

export const ActiveButtonGroup: FC<Props> = ({
  className,
  onClick,
  selected,
}) => {
  const { t } = useTranslation()

  const buttons = taskActivities.map((activity) => ({
    className: 'flex-1 text-sm',
    children: t(`features.taskPicker.${activity}`),
    selected: activity === selected,
    onClick: () => onClick(activity),
  }))

  return <ButtonGroup className={className} buttons={buttons} />
}
